import { filterActiveCandidates, filterNoActionTakenCandidates, isOrnnovaScreenRejectCandidate } from './candidateStatus';

/** Total uploaded profiles for a requirement (includes rejected). */
export function getAllUploadedCandidatesForRequirement(requirement) {
  if (!requirement) return [];
  if (Array.isArray(requirement.uploadedCandidates)) {
    return requirement.uploadedCandidates;
  }
  return [];
}

/** Uploaded profiles counted in Admin "No of Profiles" (excludes ORNNOVA Screen Reject). */
export function getNoOfProfilesCandidatesForRequirement(requirement) {
  return getAllUploadedCandidatesForRequirement(requirement)
    .filter((candidate) => !isOrnnovaScreenRejectCandidate(candidate));
}

/** Admin "No of Profiles" count — all uploaded except ORNNOVA Screen Reject. */
export function getUploadedProfileCount(requirement) {
  if (!requirement) return 0;
  if (Array.isArray(requirement.uploadedCandidates)) {
    return getNoOfProfilesCandidatesForRequirement(requirement).length;
  }
  if (typeof requirement.uploadedCandidatesCount === 'number') {
    return requirement.uploadedCandidatesCount;
  }
  return (requirement.uploadedCandidates || []).length;
}

/** Non-rejected uploaded profiles: total uploaded minus rejected. */
export function getOngoingProfileCount(requirement) {
  if (!requirement) return 0;
  if (typeof requirement.activeCandidatesCount === 'number') {
    return requirement.activeCandidatesCount;
  }
  if (typeof requirement.uploadedCandidatesCount === 'number') {
    const rejected = requirement.rejectedCandidatesCount || 0;
    return Math.max(0, requirement.uploadedCandidatesCount - rejected);
  }
  return filterActiveCandidates(requirement.uploadedCandidates || []).length;
}

export function getActiveCandidatesForRequirement(requirement) {
  if (!requirement) return [];
  if (Array.isArray(requirement.uploadedCandidates) && requirement.uploadedCandidates.length > 0) {
    return filterActiveCandidates(requirement.uploadedCandidates);
  }
  return [];
}

export function getNoActionCandidatesForRequirement(requirement) {
  if (!requirement) return [];
  if (Array.isArray(requirement.uploadedCandidates) && requirement.uploadedCandidates.length > 0) {
    return filterNoActionTakenCandidates(requirement.uploadedCandidates);
  }
  if (Array.isArray(requirement.noactionCandidates)) {
    return requirement.noactionCandidates;
  }
  return [];
}

export function getNoActionCandidateCount(requirement) {
  return getNoActionCandidatesForRequirement(requirement).length;
}
